import { useReduxState } from 'hooks';
import { Button } from 'components/common';
import { EditorBlockCustomControls } from 'components/editor/blocks';

interface Props {
  onInsertColumn: () => void;
  onInsertRow: () => void;
  onRemoveColumn: () => void;
  onRemoveRow: () => void;
}

const EditorBlockTableControls = ({
  onInsertColumn,
  onInsertRow,
  onRemoveColumn,
  onRemoveRow
}: Props) => {
  const { messages } = useReduxState();

  return (
    <EditorBlockCustomControls>
      <Button
        category="light"
        customIcon="add-row"
        data-tooltip={messages.editorBlockTableInsertRow}
        iconStyle={{ fontSize: '1.4rem' }}
        onClick={onInsertRow}
        size="small"
        style={{ marginRight: 5 }}
      />
      <Button
        category="light"
        customIcon="remove-row"
        data-tooltip={messages.editorBlockTableRemoveRow}
        iconStyle={{ fontSize: '1.4rem' }}
        onClick={onRemoveRow}
        size="small"
        style={{ marginRight: 5 }}
      />
      <Button
        category="light"
        customIcon="add-col"
        data-tooltip={messages.editorBlockTableInsertColumn}
        iconStyle={{ fontSize: '1.4rem' }}
        onClick={onInsertColumn}
        size="small"
        style={{ marginRight: 5 }}
      />
      <Button
        category="light"
        customIcon="remove-col"
        data-tooltip={messages.editorBlockTableRemoveColumn}
        iconStyle={{ fontSize: '1.4rem' }}
        onClick={onRemoveColumn}
        size="small"
      />
    </EditorBlockCustomControls>
  );
};

export default EditorBlockTableControls;
